
import "./popupFinPartie.scss";

import { Component } from "react";
import PopupManager from '../PopupManager';

import imageCoffreMobile from "../../../images/epreuve_bandeau_et_coffre.svg";
import imageCoffre from "../../../images/epreuve_coffre.svg";
import { createRef } from 'react';

interface IPopupFinPartieProps{
    pm:PopupManager,
    valeur:number,
    niveau:number
}
type IPopupFinPartieState = {
    ecus:number;
}

class PopupFinPartie extends Component<IPopupFinPartieProps,IPopupFinPartieState> {

  pm:PopupManager;    
  valeur:number;
  niveau:number;
  en_jeu_ref_DOM = createRef<HTMLDivElement>();
  
  constructor(props:any){
    super(props);
    this.state = this.getInitialState();
    this.pm = props.pm;
    this.valeur = props.valeur;
    this.niveau = props.niveau;
  }

  getInitialState():IPopupFinPartieState{
    return(
        {
          ecus:0
        }
    )
  }


  componentDidMount(){     
    
    setTimeout(() => {
      
      this.pm.app.audioManager.current?.play("fin_partie");
      // Scroll vers la partie intéressante, s'il y a lieu
    }, 300);
    
  }

  fermerFinPartie(){    
    this.pm.closePopup("fin_partie");
  }

  getEcusText(){
    const ecusText = (this.valeur > 1) ? "écus" : "écu";
    return ecusText;
  }

  getTitre(){
    if(this.valeur >= 120){
      return "Prince";
    } else if(this.valeur >= 105){
      return "Seigneur";
    } else if(this.valeur >= 90){
      return "Baron";
    } else if(this.valeur >= 75){
      return "Chevalier";
    } else if(this.valeur >= 60){
      return "Ecuyer";
    } else if(this.valeur >= 45){
      return "Valet";
    } else if(this.valeur >= 20){
      return "Palfrenier";
    } else {
      return "Serf";
    }
  }
  getTitreTextuel(){
    if(this.valeur >= 120){
      return "Prince";
    } else if(this.valeur >= 105){
      return "Seigneur";
    } else if(this.valeur >= 90){
      return "Baron";
    } else if(this.valeur >= 75){
      return "Chevalier";
    } else if(this.valeur >= 60){
      return "Écuyer";
    } else if(this.valeur >= 45){
      return "Valet";
    } else if(this.valeur >= 20){
      return "Palefrenier";
    } else {
      return "Serf";
    }
  }
  

  getRenderedEpee(){
    return(
      <div className="wrap_epee">
        <div className={`titres ${this.getTitre()}`}>
          <span className="Prince">Prince</span>
          <span className="Seigneur">Seigneur</span>
          <span className="Baron">Baron</span>
          <span className="Chevalier">Chevalier</span>
          <span className="Ecuyer">Écuyer</span>
          <span className="Valet">Valet</span>
          <span className="Palfrenier">Palefrenier</span>
          <span className="Serf">Serf</span>
        </div>
        <div className="epee"></div>
      </div>
    )
  }

  getRenderedBtnContinuer(){
    return(
      <div className="wrap-btn-continuer">
        <button className="continuer" onClick={() => {this.fermerFinPartie()}}>Continuer</button>
      </div>
    )
  }
  
  render() {    
    return (
        <div className="popup question">
            <div className="entete">
                <div className="votre_score">
                    <h3>Votre score :</h3>
                </div>
                <div className="pointage" ref={this.en_jeu_ref_DOM}>
                  <h3>{this.valeur}</h3>
                  <span>{this.getEcusText()}</span>
                </div>
                <img src={imageCoffreMobile} className="coffre_mob" alt="Coffre" />
                <img src={imageCoffre} className="coffre_pc" alt="Coffre" />
            </div>
            <div className="zone_titre">
              <p>Votre titre :</p>
              <h3>{this.getTitreTextuel()}</h3>
            </div>
            <div className="zone_epee">
                {this.getRenderedEpee()}
                {this.getRenderedBtnContinuer()}
            </div>
        </div>  
    )
  }
}

export default PopupFinPartie;
